"use client";

import * as React from "react";
import { Navigate } from "react-router-dom";
import { useOptionalAuth } from "@/lib/auth/auth-context";
import { belongsToNoOrganisation } from "@/lib/auth/organisation";

/**
 * 3.143 (the sponsor, 2026-10-11): an account with no organisation never sees
 * tenant pages. Any tenant route sends it to /platform, rather than drawing a
 * dashboard of requests that fail because it has no tenant. Tenant users, and
 * the mock console, which has no token, render as before.
 *
 * Like RequireAuth, this is a convenience and not a security boundary: the
 * gateway authorises every request.
 */
export function RequireOrganisation({ children }: { children: React.ReactNode }) {
  const auth = useOptionalAuth();
  if (auth && belongsToNoOrganisation(auth.status, auth.claims)) return <Navigate to="/platform" replace />;
  return <>{children}</>;
}
